export type Tramo = {
  id: string
  name: string
  level: string
  price: string
  original: string
  savings: string
  summary: string
  /** Link directo al carrito de la tienda. */
  checkoutUrl: string
  /** Clase de color del cuadrado identificador del tramo. */
  accent: string
}

/** Las 8 áreas del conocimiento incluidas en cada tramo. */
export const subjects = [
  '📘 Matemáticas',
  '📗 Física y Química',
  '🌿 Ciencias Biológicas',
  '🌍 Ciencias de la Tierra y el Espacio',
  '📖 Lengua Española',
  '🏛️ Historia',
  '🗺️ Geografía',
  '⚖️ Formación para la Ciudadanía',
]

export const tramos: Tramo[] = [
  {
    id: 'tramo-1',
    name: 'Pack Tramo 1',
    level: 'Inicial',
    price: '$690',
    original: '$1.990',
    savings: '$1.300',
    summary: '8 tomos + 6 bonos + 400 actividades',
    checkoutUrl: 'https://tufenixdigital.store/cart/53832899985772:1',
    accent: 'bg-sky',
  },
  {
    id: 'tramo-2',
    name: 'Pack Tramo 2',
    level: '1º y 2º',
    price: '$690',
    original: '$1.990',
    savings: '$1.300',
    summary: '8 tomos + 6 bonos + 400 actividades',
    checkoutUrl: 'https://tufenixdigital.store/cart/53939688046956:1',
    accent: 'bg-sage',
  },
  {
    id: 'tramo-3',
    name: 'Pack Tramo 3',
    level: '3º y 4º',
    price: '$690',
    original: '$1.990',
    savings: '$1.300',
    summary: '8 tomos + 6 bonos + 400 actividades',
    checkoutUrl: 'https://tufenixdigital.store/cart/53939663012204:1',
    accent: 'bg-coral-soft',
  },
  {
    id: 'tramo-4',
    name: 'Pack Tramo 4',
    level: '5º y 6º',
    price: '$690',
    original: '$1.990',
    savings: '$1.300',
    summary: '8 tomos + 6 bonos + 400 actividades',
    checkoutUrl: 'https://tufenixdigital.store/cart/53939690602860:1',
    accent: 'bg-lilac',
  },
]
